import { Component, Input } from '@angular/core'
import { AnalyticsModel } from '@flocasts/experience-service-types'

@Component({
  selector: 'old-flo-tab',
  template: `
    <a role="tabpanel" [hidden]="!active" class="pane" tabIndex="-1" [routerLink]="route" [queryParams]="qp">
      <ng-content></ng-content>
    </a>
  `
})
export class OldTabComponent {
  @Input() public tabTitle = 'Tab'
  @Input() public active = false
  @Input() public route = ''
  @Input() public analyticsName = ''
  @Input() public count: number
  @Input() public qp: any
  @Input() public analytics?: AnalyticsModel
}
